import React from 'react';
import Autosuggest from 'react-autosuggest';

export default class AutoCompleteInput extends React.Component {
    constructor(props) {
        super(props);
        //console.log("hh",(props.value || ''));
        this.state = {
            value: (props.value || ''),
            options: props.options,
            suggestions: [],
            suburbs: [],
            suggestionsSet: []
        }
        this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
        this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
        this.renderSuggestion = this.renderSuggestion.bind(this);
        this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps){
       if(this.props.value != prevProps.value){
        this.setState({
            value: this.props.value
        });
       }
    }

    onSuggestionsClearRequested() {
        this.setState({
            suggestions: []
        });
    }

    onSuggestionsFetchRequested({ value }) {
        console.log(value);
        const suggestions = this.props.getSuggestions(value);
        this.setState({
            suggestions,
        })
    }

    getSuggestionValue(suggestion) {
        return suggestion.value;
    }

    shouldRenderSuggestions(value) {
        return value.trim().length >= 3;
    }

    renderSuggestion(suggestion) {
        return (
            <div>
                { suggestion.display }
            </div>
        );
    }

    renderInputComponent(inputProps) {
        return (
            <div className="relative">
                <input {...inputProps} autoComplete="disabled" />
                <span className="error-indicator"></span>
                <span className="warning-indicator"></span>
            </div>
        );
    }

    renderSuggestionsContainer({ containerProps, children, query }) {
        return (
            <div {...containerProps} className="suggestions-dropdown" >
                {children}
            </div>
        )
    }

    onChange(e, { newValue }) {
        e.persist();
        this.setState({
            value: newValue
        });
        this.props.onChange(e);
    }

    onKeyPress = (e) => {
        e.persist();
        this.setState({
            lastPressed: e.key,
        });
    }

    onBlur = (e, { highlightedSuggestion }) => {
        e.persist();

        if (this.state.lastPressed === 'Tab' && highlightedSuggestion) {
            const mockEvent = {
                preventDefault: () => {},
            };
            this.onSuggestionSelected(mockEvent, {suggestion: highlightedSuggestion});
        }
    }

    onSuggestionSelected(event, {suggestion}) {
        event.preventDefault()
        this.props.onSelected(suggestion.id);
    }

    render() {

        const { value, suggestions } = this.state;
        
        const inputProps = {
            value,
            name: this.props.name,
            label: this.props.label,
            onChange: this.onChange,
            onBlur: this.onBlur,
            onKeyDown: this.onKeyPress
        };

        if (suggestions) {
            return (
                <label>
                    <span className="sub-title text--grey">{this.props.label}</span>
                    <Autosuggest
                        suggestions={suggestions}
                        inputProps={inputProps}
                        getSuggestionValue={this.getSuggestionValue}
                        shouldRenderSuggestions={this.shouldRenderSuggestions}
                        onSuggestionSelected={this.onSuggestionSelected}
                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                        renderSuggestion={this.renderSuggestion}
                        renderInputComponent={this.renderInputComponent}
                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}

                    />
                    {this.props.error && <span className="error text--red">{this.props.error}</span>}
                    {!this.props.error && this.props.warning && <span className="error text--warning">{this.props.warning}</span>}
                </label>
            );
        } else {
            return (
                <div>
                </div>
            )
        }
    }
}
